import Toaster from './toaster-view';

export default Toaster;
